import {ChangeDetectionStrategy, Component, effect, inject, input, OnDestroy, signal} from '@angular/core';
import {Subscription} from 'rxjs';
import {WPPostBlog} from '../../../../../../types/WPPostBlog';
import {UrlBuilderService} from '../../../../../../services/url-builder.service';
import {StaticBlogService} from '../../../../../../services/static-blog.service';

@Component({
  selector: 'app-search-content-related-blog-v2',
  templateUrl: './search-content-related-blog-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SearchContentRelatedBlogV2Component implements OnDestroy {
  public mainCareProviderUnitTypeId = input<number>();
  public puffs = signal<WPPostBlog[]>([]);
  private urlBuilder = inject(UrlBuilderService);
  public blogLink = signal<string[]>(this.urlBuilder.CreateBlogRouterLink());
  private loadedMainCareProviderUnitTypeId = signal<number>(null);

  private readonly limit: number = 3;
  private subscriptions: Subscription[] = [];

  constructor(private blogService: StaticBlogService) {
    effect(
      () => {
        this.prepareRelatedPosts(this.mainCareProviderUnitTypeId());
      },
      {allowSignalWrites: true},
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private prepareRelatedPosts(mainCareProviderUnitTypeId: number): void {
    if (
      this.loadedMainCareProviderUnitTypeId() == null ||
      this.loadedMainCareProviderUnitTypeId() !== mainCareProviderUnitTypeId
    ) {
      this.subscriptions.push(
        this.blogService.GetBlogByCategories([mainCareProviderUnitTypeId], null, null, null).subscribe((puffs) => {
          this.puffs.set(this.updatePuffsWIthRoutePath(puffs, this.limit));
        }),
      );
      this.loadedMainCareProviderUnitTypeId.set(mainCareProviderUnitTypeId);
    }
  }

  private updatePuffsWIthRoutePath(puffs: WPPostBlog[], limit: number): WPPostBlog[] {
    puffs.forEach((puff) => {
      puff.routePath = puff.acf.redirectedToUrl
        ? this.urlBuilder.convertRelativeUrlToRouterLink(puff.acf.redirectedToUrl)[0]
        : this.urlBuilder.CreateBlogPostRouterLink(puff.id, decodeURI(puff.slug));
    });
    if (puffs.length > limit) {
      puffs = puffs.slice(0, limit);
    }
    return puffs;
  }
}
